import CustomerContext from "@/stores/customer-context";
import { HOME_INFO_KEY } from "@/helpers/constant/enum_data";
import { homeTypes } from "@/helpers/constant/content_data";
import { Fragment, useEffect, useState, useContext } from "react";
import { className as cx } from "@/helpers/utility/class_name";
import Image from "next/image";
import style from "./home_type.module.css";

export default function HomeType({ errors, touched, onChange }) {
  const customerCtx = useContext(CustomerContext);
  const [selectedValue, setSelectedValue] = useState(null);
  const [activeList, setActiveList] = useState();
  // const [isCheck, setIsCheck] = useState(false);
  const [homeTypeList, setHomeTypeList] = useState(homeTypes);

  const onClickHandler = (el, value) => {
    //Flush active
    Object.keys(activeList).forEach((key) => {
      activeList[key]["active"] = false;
    });
    activeList[value]["active"] = !activeList[value]["active"];
    setSelectedValue(value);
  };
  useEffect(() => {
    (async () => {
      const _activeList = {};
      Object.keys(homeTypeList).forEach((key) => {
        _activeList[key] = { active: false };
      });
      setActiveList(_activeList);
      const _homeInfo = await customerCtx.getHomeInfo();
      if (!_homeInfo[HOME_INFO_KEY.HOME_TYPE]) {
        return;
      }
      _activeList[_homeInfo[HOME_INFO_KEY.HOME_TYPE]]["active"] = true;
      setSelectedValue(_homeInfo[HOME_INFO_KEY.HOME_TYPE]);
    })();
  }, []);
  useEffect(() => {
    (async () => {
      if (!selectedValue) {
        return;
      }
      const homeType = { homeType: selectedValue };
      await customerCtx.setHomeInfo(homeType);
    })();
  }, [selectedValue]);

  return (
    <div className={style.home_select_container}>
      {activeList && (
        <Fragment>
          <p>เลือกประเภทที่อยู่อาศัย</p>
          <ul className={style.home_select_wrapper}>
            {Object.keys(homeTypeList).map((key) => (
              <li key={key}>
                <div className={style.home_item_wrapper}>
                  <input
                    id={key}
                    type="radio"
                    value={key}
                    name="homeType"
                    onChange={(el) => {
                      onChange(el);
                      onClickHandler(el, key);
                    }}
                  />
                  <label
                    htmlFor={key}
                    className={cx(
                      style.home_item_icon,
                      activeList[key]["active"] ? style.active : ""
                    )}
                  >
                    <Image
                      src={homeTypeList[key].image}
                      alt={homeTypeList[key].title}
                      layout="fixed"
                      width="40"
                      height="40"
                      objectFit="contain"
                    />
                  </label>
                </div>
                <p className={style.home_type_title}>
                  {homeTypeList[key].title}
                </p>
              </li>
            ))}
          </ul>
          {errors.homeType && touched.homeType && (
            <div className={style.error_home_type_msg}>{errors.homeType}</div>
          )}
        </Fragment>
      )}
    </div>
  );
}
